import countryApi from '@/api/country.api'

export const countryService = (function () {
  'use strict'

  /**
   * Devuelve un arreglo de países de la collection de la base de datos
   */
  async function getCountries () {
    try {
        const response = await countryApi.getCountries()
        return response.data
    } catch (exception) {
        console.log(exception)
        return []
    }
  }

  /**
   * Devuelve un arreglo de provincias de la collection, a partir del id de un país
   * @param {*} countryId
   */
  async function getProvinces (countryId) {
    try {
        const response = await countryApi.getProvinces(countryId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return []
    }
  }

  /**
   * Devuelve un arreglo de ciudades de la collection, a partir del id de un país y de la provincia/estado
   * @param {*} countryId 
   * @param {*} provinceId 
   */
  async function getCities (countryId, provinceId) {
    try {
        const response = await countryApi.getCities(countryId, provinceId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return []
    }
  }

  return {
    getCountries,
    getProvinces,
    getCities
  }
})()
